import { Injectable } from '@angular/core';
import { ItemBoxController__factory } from '@data/abi';
import { TransactionDataModel } from '@models/transaction-data.model';
import { ErrorService } from '@services/error.service';
import { FeesExtension } from '@services/onchain/FeesExtension';
import { RelayService } from '@services/onchain/relay.service';
import { ProviderService } from '@services/provider.service';
import { GET_CORE_ADDRESSES } from '@shared/constants/addresses/addresses.constant';
import { adjustGasLimit } from '@shared/utils';
import { NGXLogger } from 'ngx-logger';
import { catchError, concatMap, from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ItemBoxControllerService extends FeesExtension {
  constructor(
    private providerService: ProviderService,
    private errorService: ErrorService,
    private logger: NGXLogger,
    private relayService: RelayService,
  ) {
    super();
  }

  // --- FACTORIES ---

  private createItemBoxController(chainId: number) {
    return ItemBoxController__factory.connect(
      GET_CORE_ADDRESSES(chainId).itemBoxController,
      this.providerService.getProviderForRead(),
    );
  }

  // --- CALLS ---

  withdrawActiveItems$(signer: string, chainId: number, hero: string, id: number, items: string[], itemIds: number[]) {
    this.logger.trace(`withdrawActiveItems`, hero, id, items, itemIds);
    return from(
      this.createItemBoxController(chainId).withdrawActiveItems.estimateGas(hero, id, items, itemIds, signer),
    ).pipe(
      concatMap(gasEstimation => this.updateCurrentFees$(this.providerService, gasEstimation)),
      concatMap(gas =>
        this.providerService.onChainCall(
          new TransactionDataModel({
            name: 'Withdraw active items',
            showLoadingScreen: true,
            isNeedUpdateHero: true,
            txPopulated: this.createItemBoxController(chainId).withdrawActiveItems.populateTransaction(
              hero,
              id,
              items,
              itemIds,
              signer,
            ),
            gasLimit: adjustGasLimit(gas),
            maxFeePerGas: this.maxFeePerGas,
            maxPriorityFeePerGas: this.maxPriorityFeePerGas,
            gasPrice: this.gasPrice,
            isDelegatedRelayPossible: true,
            relayService: this.relayService,
          }),
        ),
      ),
      catchError(this.errorService.onCatchError),
    );
  }
}
